<template>
  <div class="specificityItemList" v-if="specificityList != null && specificityList.length > 0">
    <specificity-item
      v-for="(specificity , index) in specificityList"
      :specificity="specificity"
      :index="index"
      :key="index"
      :len="specificityList.length"
    />
  </div>
</template>

<script>
  import SpecificityItem from "./SpecificityItem";
  import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'

  export default {
    name: "specificity-item-list",
    components : {
      SpecificityItem
    } ,
    computed : {
      ...mapState('contactUsStore' , [
        'selectedSpecificity' ,
        'specificityList'
      ])
    },
    methods : {
      ...mapMutations('contactUsStore' , ['API__GET__CATEGORIES']) ,
    }

  }
</script>

<style scoped lang="scss">
  .specificityItemList{
    display: flex;
    flex-direction: row;

  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/SpecificityItemList.vue